/**
 * @Author: Anandp
 * @Date:   2024-04-17 18:40:50
 * @Last Modified by:   Anandp
 * @Last Modified time: 2024-12-23 16:33:07
 */
import React, { useEffect } from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { ReactComponent as SmartLeaderLogo } from "../../icons/untitled-ui/smartLeaderWhite.svg";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
// import SurveyTile from "./surveys/surveyCards";
import LeadershipBrandSurveyTile from "./leadershipBrandComponents/surveyCards";
import { RouterLink } from "src/components/router-link";
// import surveyAPIService from "src/services/surveyApi";
import surveyAPIService from "src/services/surveyApi";
import { useUser } from "src/hooks/use-user";
import { useState } from "react";
import { createTypography } from "src/theme/base/customTypography";
import loginApiService from "src/services/loginAPI";
import { useLocation } from "react-router";
import * as SldButtons from "src/theme/base/SldButtons";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import * as SldSurveyCard from "src/theme/base/SldSurveyCard";
import LinkExpired from "../wiredUpSurveys/surveys/linkExpire";



/**
 * LBS survey start page component
 *
 * @module LBSsurveyStartPage
 * @param {object} props - Component properties.
 * @returns {JSX.Element} The rendered component. 
 */
function LeadershipBrandSurveyStartPage(props) {
  const { children } = props;
  // const id = 7;
  // eslint-disable-next-line
  const token = "tokenuser";
  // const sectionPage = 1;  

  const accesssToken = sessionStorage.getItem("accessToken");
  // eslint-disable-next-line
  const user = useUser();
  const queryParameters = new URLSearchParams(window.location.search);
  // const surveyId = queryParameters.get("surveyId");
  // const queueId = queryParameters.get("queueId");
  const location = useLocation();

  // const surveyId = 5;
  const [inviteId, setInviteId] = useState(null);
  const [userId, setUserId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  // const [teamId,setTeamId] = useState(null);
  const [queueId, setQueueId] = useState();
  const [invitedUserId, setInvitedUserId] = useState(null)
  const [tenantId, setTenantId] = useState(null)
  const [surveyId, setSurveyId] = useState(queryParameters.get("surveyId"));
  const [valid, setValid] = useState(0);
  let surveyLinkParameters = '';

  /**
   * Function to get invite id , If no invite id is present new invite id will be created
   * @date 11/5/2023 - 12:07:16 AM
   *
   * @async
   * */
  const getInviteId = async () => {
    try {
      const inviteIdGetData = {
        survey_id: surveyId,
        inviteId: inviteId,
        timeStamp: "",
        teamId: "",
      };
      //api call to check invite id
      const response = await surveyAPIService.checkInviteId(
        inviteIdGetData,
        accesssToken
      );
      setInviteId(response.data.inviteId);
      setIsLoading(false);
    } catch (error) { }
  };
 /**
   * Function to validate the token which get from survey link
   *
   * @async
   * @returns {*} 
   */
  const validateToken = async () => {
    try {
      const response = await loginApiService.decodeToken('');
      if (response?.userId) {
        setUserId(response?.userId);
        const stringifiedUser = JSON.stringify(response)
        sessionStorage.setItem("userDetails", stringifiedUser);
      }


    } catch (error) {
console.log(error);

    }
  }
  // useEffect(() => {
  //   if (location.search.substring(1)) {
  //     const base64String = location.search.substring(1);

  //     // Decode the base64 string to get the original string
  //     const decodedString = atob(base64String);

  //     // Split the decoded string to get individual parameters
  //     const paramsArray = decodedString.split('&');

  //     // Create an object to store the parameters
  //     const params = {};

  //     // Populate the params object
  //     paramsArray.forEach(param => {
  //       const equalSignIndex = param.indexOf('=');
  //       const key = param.slice(0, equalSignIndex);
  //       const value = param.slice(equalSignIndex + 1);
  //       params[key] = value;
  //     });
  //     // Set your state variables accordingly
  //     setEmailInviteId(params.inviteId);
  //     setEmailToken(params.token);
  //     setSurveyId(params.surveyId);
  //     setQueueId(params.queueId);
  //     // setTeamId(params.teamId);
  //     setInvitedUserId(params.invitedUserId);
  //     setTenantId(params.tenantId);
  //   } else {
  //     getInviteId();
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [location.search])
  useEffect(() => {
    const init = async () => {
      if (location.search.substring(1) && !queryParameters.get("surveyId")) {
        const base64String = location.search.substring(1);
  
        // Decode
        const decodedString = atob(base64String);
  
        // Split params
        const paramsArray = decodedString.split("&");
        const params = {};
  
        paramsArray.forEach((param) => {
          const equalSignIndex = param.indexOf("=");
          const key = param.slice(0, equalSignIndex);
          const value = param.slice(equalSignIndex + 1);
          params[key] = value;
        });
      // setEmailInviteId(params.inviteId);
          // setEmailToken(params.token);
          setSurveyId(params.surveyId);
          setQueueId(params.queueId);
          setInvitedUserId(params.invitedUserId);
          setTenantId(params.tenantId)
        // Set state  
        
        // setEmailToken(params.token);
     
      
  
        await loginApiService.setCookie(params.token);
        await validateToken();
        setInviteId(params.inviteId);
      } 
      else{
        getInviteId();
      }
      
    };
  
    init();
  
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.search]);
  const typography = createTypography();
  /**
 * Validates the survey invitation link using the provided email token and invite ID.
 * Updates the validation state based on the response.
 *
 * @async
 * @function validateLink
 * @returns {Promise<void>}
 */
  const validateLink = async () => {
    try {
      const response = await loginApiService.validateTeamLink('', queueId,tenantId,inviteId,userId);
      if(response.length> 0){

        if(response[0].is_deleted  || response[0].active === 0 || response[0].is_completed){
          setValid(1);
  
        }
  
        else{
          setValid(0)
        }
      }
      else{
        setValid(1)
      }
      setIsLoading(false)
    } catch (error) {

console.error('Error occurred while validating the link:',  error)
    }
  }
  useEffect(() => {
    if (inviteId ) {
      validateLink();
    }
    // eslint-disable-next-line
  }, [inviteId])


  if (tenantId) {
    surveyLinkParameters = `&tenantId=${tenantId}`
  }

  if (isLoading) {
    return (
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={isLoading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    );
  }
  if (valid === 1) {
    return <LinkExpired />;
  }
  return (
    <SldSurveyCard.SurveyGrid
      container
      spacing={0}

    >
      <SldSurveyCard.SurveyGridItem
        item
        lg={12}
        sm={12}
      >
        <SldSurveyCard.SurveyLogo>
          <SmartLeaderLogo width='250' />
        </SldSurveyCard.SurveyLogo>
        <Stack
          direction="column"
          justifyContent="flex-start"
          alignItems="center"
          spacing={6}

        >
          <Typography
            sx={typography.qNheading}
            style={{ padding: '5px', }}

          >
            Leadership Brand Survey Questionnaire
          </Typography>


        </Stack>
      </SldSurveyCard.SurveyGridItem>
      <SldSurveyCard.SurveyStack
        spacing={3}

        sx={{
          marginTop: { lg: '-140px', sm: '5px', xs: '3px' },
          padding:{lg:'0 60px', md:'0 60px', sm:'0 0', xs:'0'},
        }}
      >
        <LeadershipBrandSurveyTile />
        <SldSurveyCard.SurveyRules
          lg={12}
        >
          <SldSurveyCard.SurveyContainer>{children}</SldSurveyCard.SurveyContainer>
          {/* </SurveyStack> */}
          <SldButtons.WhiteButtonCap endIcon={<ArrowForwardIcon />}
            style={{ marginTop: '15px' }}
            component={RouterLink}
            to={`/surveyQuestions?id=${surveyId}&inviteId=${inviteId}&invitedUserId=${invitedUserId}&queueId=${queueId}${surveyLinkParameters}`}
          >
            <Typography sx={typography.startButton}>Start</Typography>
          </SldButtons.WhiteButtonCap>
        </SldSurveyCard.SurveyRules >
      </SldSurveyCard.SurveyStack>
    </SldSurveyCard.SurveyGrid>
  );
}

export default LeadershipBrandSurveyStartPage;
